import {z} from 'zod';

import i18n from '@dms/i18n';

const requiredMessage = () => i18n.t('general.validations.fieldIsRequired');

export const VehicleWarrantyFormSchema = z.object({
  warrantyProductId: z
    .string({required_error: requiredMessage(), invalid_type_error: requiredMessage()})
    .min(1, requiredMessage()),
  startDate: z.date({required_error: requiredMessage(), invalid_type_error: requiredMessage()}),
  endDate: z.date().nullable(),
  startOdometerKm: z.number().nullable(),
  endOdometerKm: z.number().nullable(),
});

export type VehicleWarrantyFormType = z.infer<typeof VehicleWarrantyFormSchema>;
